import { useSelector } from 'react-redux'
import React, { useState } from 'react'

import {
  loadAllOccupationListing,
  loadSubsequentOccupationsListing
} from '../../actions/occupations/occupations'
import SearchQueryHandlerComponent from '../../components/search/SearchQueryHandlerComponent'

const OccupationListing = props => {
  const [filterModel, setFilterModel] = useState({})
  const loadFunction = loadAllOccupationListing
  const loadMoreFunction = loadSubsequentOccupationsListing(filterModel)
  const searchRequest = useSelector(state => state.occupations.allOccupationsRequest)

  return (
    <SearchQueryHandlerComponent
      loadFunction={loadFunction}
      loadMoreFunction={loadMoreFunction}
      setFilterModel={setFilterModel}
      searchRequest={searchRequest}
      {...props}
    />
  )
}

export default OccupationListing
